import Model from "./abstract/Model";

export const StrandingType = {
  DAMAGE: 'DAMAGE',
  BREAKDOWN: 'BREAKDOWN',
  OTHER: 'OTHER',
}

export default class ConkedOutVehicle extends Model {
  country_id;

  brand_name;
  model_name;
  license_plate;

  remark;

  constructor(props) {
    super();

    this.initializeAttributes(props)
  }
}
